import { get, postRaw } from "../../api/service/services";
import allUrl from "../../api/allUrl";
import { Toast } from "antd-mobile-v2";
export const GenderData = [
  {
    label: "男",
    value: "1",
  },
  {
    label: "女",
    value: "0",
  },
];
export const formInputData = [
  {
    name: "工作单位",
    type: "userOrganization",
    reg: "",
    errorText: "",
    placeholder: "请输入工作单位",
  },
  {
    name: "邮政编码",
    type: "postCode",
    reg: /^[1-9]\d{5}(?!\d)$/,
    errorText: "请输入正确的邮政编码",
    placeholder: "请输入邮政编码",
  },
  {
    name: "电子邮箱",
    type: "emailAddress",
    reg: /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/,
    errorText: "请输入正确的电子邮箱",
    placeholder: "请输入电子邮箱",
  },
  {
    name: "户口所在地",
    type: "regAddress",
    reg: "",
    errorText: "",
    placeholder: "请输入户口所在地",
  },
  {
    name: "通讯地址",
    type: "contactAddress",
    reg: "",
    errorText: "",
    placeholder: "请输入通讯地址",
  },
  {
    name: "固定电话",
    type: "homeNumber",
    reg: /^\d{3,4}-\d{7,8}$/,
    errorText: "请输入正确的固定电话",
    placeholder: "请输入固定电话",
  },
];
// 处理数据变成组件所需数据
function childrenVal(data, obj) {
  data.length > 0 &&
    data.map((item) => {
      item.value = item[obj[0]];
      item.label = item[obj[1]];
      if (item.children && item.children.length > 0) {
        childrenVal(item.children, obj);
      }
    });
  return data;
}
//获取证件类型
export const getDocType = () => {
  return new Promise((resolve, reject) => {
    get(allUrl.register.getDocType, { code: "card_type" }).then((res) => {
      if (res.success === true && res.code == 200) {
        let data = res && res.data ? res.data : [];
        let newData = childrenVal(data, ["dictKey", "dictValue"]);
        resolve(newData);
      }
    });
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      Toast.fail("证件类型获取失败", 1);
    });
};
//获取密保问题
export const getQuestion = () => {
  return new Promise((resolve, reject) => {
    get(allUrl.register.getDocType, { code: "pass_quest" }).then((res) => {
      if (res.success === true && res.code == 200) {
        let data = res && res.data ? res.data : [];
        let newData = childrenVal(data, ["dictKey", "dictValue"]);
        resolve(newData);
      }
    });
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      Toast.fail("密保问题数据获取失败", 1);
    });
};
//获取人员类型
export const getUserType = () => {
  return new Promise((resolve, reject) => {
    postRaw(
      allUrl.register.getCategory,
      { code: "quntileixing" },
      {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    ).then((res) => {
      if (res.success === true && res.code == 200) {
        let data = JSON.parse(res.data);
        let newData = childrenVal(data, ["dicCode", "dicName"]);
        resolve(newData);
      }
    });
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      Toast.fail("人员类型数据获取失败", 1);
    });
};

//获取职业数据
export const getJobData = () => {
  return new Promise((resolve, reject) => {
    get(allUrl.register.getDocType, { code: "job_type" }).then((res) => {
      if (res.success === true && res.code == 200) {
        let data = res && res.data ? res.data : [];
        let newData = childrenVal(data, ["dictKey", "dictValue"]);
        resolve(newData);
      }
    });
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      Toast.fail("职业数据获取失败", 1);
    });
};
export const nation_data = [
  { value: "1", label: "汉族" },
  { value: "2", label: "蒙古族" },
  { value: "3", label: "回族" },
  { value: "4", label: "藏族" },
  { value: "5", label: "维吾尔族" },
  { value: "6", label: "苗族" },
  { value: "7", label: "彝族" },
  { value: "8", label: "壮族" },
  { value: "9", label: "布依族" },
  { value: "10", label: "朝鲜族" },
  { value: "11", label: "满族" },
  { value: "12", label: "侗族" },
  { value: "13", label: "瑶族" },
  { value: "14", label: "白族" },
  { value: "15", label: "土家族" },
  { value: "16", label: "哈尼族" },
  { value: "17", label: "哈萨克族" },
  { value: "18", label: "傣族" },
  { value: "19", label: "黎族" },
  { value: "20", label: "傈僳族" },
  { value: "21", label: "佤族" },
  { value: "22", label: "畲族" },
  { value: "23", label: "高山族" },
  { value: "24", label: "拉祜族" },
  { value: "25", label: "水族" },
  { value: "26", label: "东乡族" },
  { value: "27", label: "纳西族" },
  { value: "28", label: "景颇族" },
  { value: "29", label: "柯尔克孜族" },
  { value: "30", label: "土族" },
  { value: "31", label: "达翰尔族" },
  { value: "32", label: "么佬族" },
  { value: "33", label: "羌族" },
  { value: "34", label: "布朗族" },
  { value: "35", label: "撒拉族" },
  { value: "36", label: "毛南族" },
  { value: "37", label: "仡佬族" },
  { value: "38", label: "锡伯族" },
  { value: "39", label: "阿昌族" },
  { value: "40", label: "普米族" },
  { value: "41", label: "塔吉克族" },
  { value: "42", label: "怒族" },
  { value: "43", label: "乌孜别克族" },
  { value: "44", label: "俄罗斯族" },
  { value: "45", label: "鄂温克族" },
  { value: "46", label: "德昂族" },
  { value: "47", label: "保安族" },
  { value: "48", label: "裕固族" },
  { value: "49", label: "京族" },
  { value: "50", label: "塔塔尔族" },
  { value: "51", label: "独龙族" },
  { value: "52", label: "鄂伦春族" },
  { value: "53", label: "赫哲族" },
  { value: "54", label: "门巴族" },
  { value: "55", label: "珞巴族" },
  { value: "56", label: "基诺族" },
];
export const idTypeData = [
  {
    id: "1273905686723473415",
    tenantId: "",
    parentId: "1273905686723473414",
    code: "card_type",
    value: "01",
    label: "身份证",
    sort: 1,
    remark: "",
    isSealed: -1,
    isDeleted: -1,
  },
];
